interface HideEyeIconProps extends React.ComponentPropsWithoutRef<'svg'> {
  color?: string;
}

export function HideEyeIcon({ color = 'currentColor', ...svgProps }: HideEyeIconProps) {
  return (
    <svg
      width="30"
      height="20"
      viewBox="0 0 30 20"
      fill={'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M29 9C29 9 22.732 17 15 17C7.26801 17 1 9 1 9C1 9 7.26801 1 15 1C22.732 1 29 9 29 9Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="7.81699"
        y1="17.317"
        x2="8.81699"
        y2="15.5849"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="0.5"
        y1="-0.5"
        x2="2.5"
        y2="-0.5"
        transform="matrix(-0.5 -0.866025 -0.866025 0.5 23 18)"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="15.5"
        y1="17.5"
        x2="15.5"
        y2="19.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="4"
        y1="12.7071"
        x2="2.58579"
        y2="14.1213"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="0.5"
        y1="-0.5"
        x2="2.5"
        y2="-0.5"
        transform="matrix(0.707107 0.707107 0.707107 -0.707107 26 12)"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
